import { Stack } from '@mui/material'
import Image from 'next/image'
import { IconButton } from '@mui/material'
import { UserProfile } from './UserProfile'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'

export const Header = ({
  toggle,
  setToggle,
}: {
  toggle: boolean
  setToggle: React.DispatchWithoutAction
}) => {
  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      borderBottom='1px solid #DDDDDD'
      width='100%'
      sx={{ background: '#ffffff' }}
      px={3.5}
      py={2}
    >
      <IconButton onClick={() => setToggle()}>
        {toggle ? (
          <KeyboardDoubleArrowLeftIcon />
        ) : (
          <KeyboardDoubleArrowRightIcon />
        )}
      </IconButton>
      <Stack direction='row' gap={1.5}>
        <Image
          src='/profile.svg'
          width={40}
          height={40}
          alt='プロフィール画像'
        />
        <UserProfile />
      </Stack>
    </Stack>
  )
}
